import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";

export enum NavItemsId {
  HOME = "menu-home",
  PEDIDOS = "menu-pedidos",
  PORTAL = "menu-portal",
  IMPRESSAO = "menu-impressao",
}

export interface ItemMenu {
  id: string;
  title: string;
  icon: string;
  visible: boolean;
  path?: string;
  action?: any;
}

@Injectable({
  providedIn: "root",
})
export class MenuService {
  menuAtivo: string;
  urlLoja: string;
  urlApp: string;

  constructor() {
    this.menuAtivo = NavItemsId.HOME;
  }

  menu = [
    {
      id: NavItemsId.HOME,
      title: "Home",
      icon: "home",
      visible: true,
      path: "/",
    },
    {
      id: NavItemsId.PEDIDOS,
      title: "Pedidos",
      icon: "article",
      visible: true,
      path: "/pedidos",
    },
    {
      id: NavItemsId.IMPRESSAO,
      title: "Configurar",
      icon: "settings",
      visible: true,
      path: "/impressao",
    },
    {
      id: NavItemsId.PORTAL,
      title: "Portal",
      icon: "desktop_windows",
      visible: true,
      path: null,
      action: () => {
        window.open(this.urlLoja, "_blank");
      },
    },
    {
      id: NavItemsId.PORTAL,
      title: "App",
      icon: "phone_android",
      visible: true,
      path: null,
      action: () => {
        window.open(this.urlApp, "_blank");
      },
    },
  ];
}
